// @flow
import moment from 'moment';
import Opportunity from 'common/modules/proposition/domain/opportunity';

export type EstimationProgressStep =
  | 'QUEUED'
  | 'ESTIMATION_STARTED'
  | 'ESTIMATING_ROW'
  | 'ESTIMATING_SUMMARY'
  | 'SUCCESS'
  | 'ERROR';

export type RowStep = number;

function stepNumber(step: EstimationProgressStep) {
  return {
    'QUEUED': 0,
    'ESTIMATION_STARTED': 1,
    'ESTIMATING_ROW': 2,
    'ESTIMATING_SUMMARY': 3,
    'SUCCESS': 4,
    'ERROR': 4,
  }[step] || 0;
}

export type SalesEstimationSuccessData = {
  totalCost: number;
}

type ProgressData = {
  reference: string,
  callSign: string,
  step: EstimationProgressStep,
  data: RowStep | SalesEstimationSuccessData | void,
}

export class EstimationProgress {
  reference: string;
  callSign: string;
  step: EstimationProgressStep;
  data: RowStep | SalesEstimationSuccessData | void;

  constructor(data: ProgressData) {
    this.reference = data.reference;
    this.callSign = data.callSign;
    this.step = data.step;
    this.data = data.data;
  }

  currentProgress(totalRows: number) {
    const totalSteps = 2 + totalRows;
    const currentRow = typeof this.data === 'number' ? this.data : 0;

    switch (this.step) {
      case 'QUEUED':
        return 0;
      case 'ESTIMATION_STARTED':
        return 0;
      case 'ESTIMATING_ROW':
        return (1 + currentRow) / totalSteps;
      case 'ESTIMATING_SUMMARY':
        return (1 + totalRows) / totalSteps;
      case 'SUCCESS':
        return 1;
      case 'ERROR':
        return 1;
      default: return 0;
    }
  }

  is(step: EstimationProgressStep) {
    return this.step === step;
  }

  isAfter(step: EstimationProgressStep) {
    return stepNumber(step) > stepNumber(this.step);
  }

  isStarted() {
    return this.step && this.step !== 'QUEUED';
  }

  static parse(data: Object) {
    return new EstimationProgress({
      reference: data.reference,
      callSign: data.callSign,
      step: data.progressType,
      data: data.data,
    });
  }
}

export type EstimationProgressRequest = {
  sentOn: moment,
  request: Opportunity[],
  progress: EstimationProgress,
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/domain/estimationProgress.js